import React from 'react';
import { Route } from 'react-router-dom';
import { LoginRequiredContainer, UnauthenticatedOnlyContainer } from '@saucelabs/sl-container-authentication';

import LoginContainer from './containers/LoginContainer';
import SendPasswordResetContainer from './containers/SendPasswordResetContainer';
import VerifyPasswordResetContainer from './containers/VerifyPasswordResetContainer';
import ResetPasswordContainer from './containers/ResetPasswordContainer';
import VerifyEmailContainer from './containers/VerifyEmailContainer';
import SendVerificationEmailContainer from './containers/SendVerificationEmailContainer';
import RootContainer from './containers/RootContainer';


const LoginRoute = () => (
  <RootContainer>
    <UnauthenticatedOnlyContainer>
      <LoginContainer />
    </UnauthenticatedOnlyContainer>
  </RootContainer>
);

const SendPasswordResetRoute = () => (
  <RootContainer>
    <UnauthenticatedOnlyContainer>
      <SendPasswordResetContainer />
    </UnauthenticatedOnlyContainer>
  </RootContainer>
);

const VerifyPasswordResetRoute = () => (
  <RootContainer>
    <UnauthenticatedOnlyContainer>
      <VerifyPasswordResetContainer />
    </UnauthenticatedOnlyContainer>
  </RootContainer>
);

const ResetPasswordRoute = () => (
  <RootContainer>
    <UnauthenticatedOnlyContainer>
      <ResetPasswordContainer />
    </UnauthenticatedOnlyContainer>
  </RootContainer>
);

const VerifyEmailRoute = () => (
  <RootContainer>
    <VerifyEmailContainer />
  </RootContainer>
);

const SendVerificationEmailRoute = () => (
  <RootContainer>
    <LoginRequiredContainer>
      <SendVerificationEmailContainer />
    </LoginRequiredContainer>
  </RootContainer>
);

const AuthRoutes = () => [
  <Route
    key="login"
    component={LoginRoute}
    path="/login"
  />,
  <Route
    key="send-password-reset"
    component={SendPasswordResetRoute}
    path="/send-password-reset"
  />,
  <Route
    key="verify-password-reset"
    component={VerifyPasswordResetRoute}
    path="/verify-password-reset"
  />,
  <Route
    key="reset-password"
    component={ResetPasswordRoute}
    path="/reset-password"
  />,
  <Route
    key="verify-email"
    component={SendVerificationEmailRoute}
    path="/verify-email"
  />,
  <Route
    key="verify-email-send"
    component={VerifyEmailRoute}
    path="/verify"
  />,
];

export default AuthRoutes();
